import { SheetIcon } from "../../../ui";
import { Check } from "../components/fields";
import { useDocumentKinds } from "../hooks";
import type { Id } from "../../../api/types";

interface Props {
  values: readonly Id[];
  onChange: (ids: Id[]) => void;
  hint?: string;
}

/**
 * "Drawn on which kinds of drawing?" One box for each kind of drawing the discipline has. The answer writes the
 * "is shown on" links in the same step, so the symbol step and the drawing checks work from a link (7.10).
 */
export function DrawnOnPicker({ values, onChange, hint }: Props) {
  const { drawings, loading, error } = useDocumentKinds();
  const toggle = (id: Id, on: boolean) => onChange(on ? [...values.filter((v) => v !== id), id] : values.filter((v) => v !== id));
  return (
    <fieldset className="field field--group">
      <legend className="field__label">Drawn on which kinds of drawing?</legend>
      <p className="field__hint muted">{hint ?? "Tick every kind of drawing it appears on. Leave all empty if it is never drawn."}</p>
      {loading && <p className="muted">Loading the kinds of drawing</p>}
      {!loading && error && <p className="form-error">The kinds of drawing could not be read.</p>}
      {!loading && !error && drawings.length === 0 && (
        <p className="muted">No kind of drawing is stored in this discipline yet. Add a document kind that is a drawing first.</p>
      )}
      <ul className="check-list">
        {drawings.map((kind) => (
          <li key={kind.id}>
            {kind.deliverableKind ? <SheetIcon kind={kind.deliverableKind} size={16} label={kind.name} /> : <span className="check-list__gap" />}
            <Check
              label={kind.name}
              checked={values.includes(kind.id)}
              onChange={(on) => toggle(kind.id, on)}
              hint={kind.deliverableKind === "C" ? "Geometric: shown here without a symbol." : undefined}
            />
          </li>
        ))}
      </ul>
    </fieldset>
  );
}
